/** Publisher that scopes a notification surface to co-invest deals. */
export const COINVEST_NOTIFICATION_PUBLISHER = "coinvest-deals-app";
